import { render, staticRenderFns } from "./MollieBilling.vue?vue&type=template&id=2a8b7060&scoped=true"
import script from "./MollieBilling.vue?vue&type=script&lang=js"
export * from "./MollieBilling.vue?vue&type=script&lang=js"
import style0 from "./MollieBilling.vue?vue&type=style&index=0&id=2a8b7060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b7060",
  null
  
)

export default component.exports